import { useState } from 'react';
import { useAuthStore } from '../store/authStore';
import { toast } from 'sonner';

export function usePdfExport() {
  const token = useAuthStore(s => s.accessToken);
  const [isExporting, setIsExporting] = useState(false);

  const exportPdf = async (url: string, body: unknown, filename: string): Promise<boolean> => {
    setIsExporting(true);
    const toastId = toast.loading('Generazione PDF in corso...');
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({ error: 'Export failed' }));
        throw new Error(err.error ?? 'Export failed');
      }
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(blobUrl);
      toast.success('PDF generato e scaricato', { id: toastId });
      return true;
    } catch (e) {
      toast.error(e instanceof Error ? e.message : 'Errore esportazione', { id: toastId });
      return false;
    } finally {
      setIsExporting(false);
    }
  };

  return { isExporting, exportPdf };
}
